export const EMPLOYEE_NAV = {
  bottomNav: 'employee-bottom-nav',
  navHome: 'employee-nav-home',
  navExpediente: 'employee-nav-expediente',
  navVacaciones: 'employee-nav-vacaciones',
  logoutButton: 'employee-logout-button',
  usageGuideButton: 'employee-usage-guide-button',
};

export const EMPLOYEE_PORTAL = {
  changePasswordBanner: 'employee-change-password-banner',
  currentPasswordInput: 'change-password-current-input',
  newPasswordInput: 'change-password-new-input',
  changePasswordSubmit: 'change-password-submit-button',
  pendingPolicyCard: 'employee-pending-policy-card',
  acknowledgedPolicyCard: 'employee-acknowledged-policy-card',
  pendingPolicyViewButton: 'employee-pending-policy-view-button',
  acknowledgeButton: 'employee-acknowledge-policy-button',
  vacationBalance: 'employee-vacation-balance',
  policyReminderPinnedCard: 'employee-policy-reminder-pinned-card',
  unscheduledVacationBanner: 'employee-unscheduled-vacation-banner',
  missingPhoneBanner: 'employee-missing-phone-banner',
  missingPhoneInput: 'employee-missing-phone-input',
  missingPhoneSubmit: 'employee-missing-phone-submit-button',
};
